import { render, staticRenderFns } from "./ContractDiagnosis.vue?vue&type=template&id=039f22ba&scoped=true"
import script from "./ContractDiagnosis.vue?vue&type=script&lang=js"
export * from "./ContractDiagnosis.vue?vue&type=script&lang=js"
import style0 from "./ContractDiagnosis.vue?vue&type=style&index=0&id=039f22ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039f22ba",
  null
  
)

export default component.exports